module.exports = __webpack_public_path__ + "static/media/Logo-.035d6fb8.svg";